import React from 'react';

function CheckboxOptions({ options, value, onChange, maxChoices }) {
  const selected = Array.isArray(value) ? value : [];
  const atMax = maxChoices && selected.length >= maxChoices;

  const toggle = (code, checked) => {
    if (checked) {
      if (atMax) return; // don't add beyond max
      onChange([...selected, code]);
      return;
    }
    onChange(selected.filter((item) => item !== code));
  };

  return (
    <>
      {options.map((option) => {
        const isSelected = selected.includes(option.code);
        const isDisabled = !isSelected && atMax;
        return (
          <label
            key={option.code}
            className={`option-item${isSelected ? ' option-item--selected' : ''}${isDisabled ? ' option-item--disabled' : ''}`}
          >
            <span className="option-item__checkbox">
              <input
                type="checkbox"
                checked={isSelected}
                disabled={isDisabled}
                onChange={(e) => toggle(option.code, e.target.checked)}
              />
              <span className="option-item__check-mark">
                <svg
                  viewBox="0 0 12 12"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="2 6 5 9 10 3" />
                </svg>
              </span>
            </span>
            <span className="option-item__label">{option.label}</span>
          </label>
        );
      })}
    </>
  );
}

export default CheckboxOptions;
